require('./create');
require('./edit');
require('./list');

import RouteConfig from './currencies.route';

angular.module('BTMS')
	.config(RouteConfig);



/** WEBPACK FOOTER **
 ** ./client/private/currencies/index.js
 **/